export default __webpack_public_path__ + "0d86e7a5f9651b13f4cbb42929e694ff.png";